import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!
  const _component_Media = _resolveComponent("Media")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Emoji = _resolveComponent("Emoji")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Space = _resolveComponent("Space")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { title: "遊び方" }, {
    default: _withCtx(() => [
      _createVNode(_component_Space, {
        vertical: "",
        xlarge: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Media, { icon: _ctx.textSample }, {
            title: _withCtx(() => [
              _createVNode(_component_Text),
              _createTextVNode(" テキスト ")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" 文字からスタンプを作ります。「テキスト」欄になにか入力してみてください。 ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["icon"]),
          _createVNode(_component_Media, { icon: _ctx.imageSample }, {
            title: _withCtx(() => [
              _createVNode(_component_Image),
              _createTextVNode(" 画像ファイル ")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" 好きな画像を正方形にトリミングしてスタンプにします。 ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["icon"]),
          _createVNode(_component_Media, { icon: _ctx.fukumojiSample }, {
            title: _withCtx(() => [
              _createVNode(_component_Emoji),
              _createTextVNode(" パーツ ")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" 既存の絵文字を合成してスタンプを作ります。 ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["icon"]),
          _createVNode(_component_Button, {
            type: "text",
            onClick: _ctx.openFAQ
          }, {
            default: _withCtx(() => [
              _createTextVNode(" よくある質問 ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"]),
          _createVNode(_component_Button, {
            type: "text",
            onClick: _ctx.openLicense
          }, {
            icon: _withCtx(() => [
              _createTextVNode(" ⚖️ ")
            ]),
            default: _withCtx(() => [
              _createTextVNode(" ライセンス表示 ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}